import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { withSize } from "react-sizeme";
import styles from "components/documents/category-cell.scss";
import { isValidValue } from "utils/validators";
import xeroIconUrl from "xero-icon.svg";
import myobIconUrl from "myob-icon.svg";
import sageIconUrl from "sage-icon.svg";
import qboIconUrl from "qbo-icon.svg";
import saasuIconUrl from "saasu-icon.svg";

const CategoryCell = ({ documentCount, rowIndex, size, value }) => {
  const newValue = typeof value === "string" ? JSON.parse(value) : value;
  if (!isValidValue(newValue) || newValue.length === 0) {
    return null;
  }
  const charLength = newValue.reduce((a, b) => a + b.length, 0);
  const length = (charLength * 5) + (newValue.length * 27);
  const tooltipStyle = rowIndex < (documentCount / 2) ? styles["tooltip-bottom"] : styles["tooltip-top"];
  return (
    <div className={ styles.container }>
      { newValue.map(renderCategory) }
      { renderTooltip(length, size, newValue, tooltipStyle) }
    </div>
  );
};

export const CategoryCellFormatter = withSize()(CategoryCell);

CategoryCell.defaultProps = {
  value: []
};

CategoryCell.propTypes = {
  documentCount: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired,
  size: PropTypes.shape({ size: PropTypes.number }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]) // Stringified JSON
};

const renderTooltip = (length, size, value, tooltipStyle) => {
  if (length > size.width) {
    return (
      <div className={ tooltipStyle }>
        {value.map(renderCategory)}
      </div>
    );
  }
  return null;
};

const renderCategory = (categoryName, index) => (
  <div className={ styles.tag } key={ `${categoryName}-${index}` }>
    {renderSpecialCategoryPrefix(categoryName)}
    {renderCategoryName(categoryName)}
  </div>
);

const renderSpecialCategoryPrefix = (name) => {
  switch (true) {
    case name.startsWith("Xero"):
      return <img alt="xero icon" className={ styles.icon } height={ 12 } src={ xeroIconUrl } />;
    case name.startsWith("MYOB"):
      return <img alt="myob icon" className={ styles.icon } height={ 12 } src={ myobIconUrl } />;
    case name.startsWith("SageOne"):
      return <img alt="sage one icon" className={ styles.icon } height={ 12 } src={ sageIconUrl } />;
    case name.startsWith("QBO"):
      return <img alt="qbo icon" className={ styles.icon } height={ 12 } src={ qboIconUrl } />;
    case name.startsWith("SaasuV2"):
      return <img alt="saasu icon" className={ styles.icon } height={ 12 } src={ saasuIconUrl } />;
    case "Export failed":
      return <span className={ styles.warn }>!</span>;
    default:
      return null;
  }
};

const renderCategoryName = (name) => {
  if (
    name.startsWith("Xero") ||
    name.startsWith("MYOB") ||
    name.startsWith("SageOne") ||
    name.startsWith("QBO") ||
    name.startsWith("SassuV2")
  ) {
    return R.drop(1, name.split("-")).join("-");
  }
  return name;
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/category-cell-formatter.jsx